import type { IDirective } from "angular";
import { module } from "angular";

export default class FocusOnInitDirective implements IDirective {
    public scope = {
        irFocusOnInit: "<",
    };

    public link($scope: any, element: JQuery) {
        if ($scope.irFocusOnInit) {
            element.focus();
        }
    }
}

module("mmGui").directive("irFocusOnInit", () => new FocusOnInitDirective());
